import { Component, AfterViewChecked, OnInit, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from '../../core/service/loader/loader.service';
import { TicketService } from '../../core/service/tickets/tickets.service';
import { PlayPeriod } from '../../core/models/play-period.model';
import Ticket from '../../core/models/ticket.model';
import { AuthService } from '../../core/service/authentication/auth.service';
import { ModalService } from '../../core/service/modal/modal.service';
import { NotificationService } from '../../core/service/notifications/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements AfterViewChecked, OnInit {
  jackpotAmount = 0;
  playPeriod!: PlayPeriod;
  pagination = { currentPage: 1, totalPages: 1 };
  tickets: Ticket[] = [];
  pageSize = 5;
  page = 1;
  allowUserPurchase = false;
  isLogged = false;

  isTryMode: boolean = environment.IS_TRY_MODE;
  tryModeUrl: string = environment.TRY_MODE_URL;

  constructor(
    private loaderService: LoaderService,
    private ticketService: TicketService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private modalService: ModalService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.loaderService.showLoader();

    this.isLogged = this.authService.isAuthenticated()

    this.ticketService.playPeriod$.subscribe(playPeriod => {
      if (playPeriod) {
        this.allowUserPurchase = playPeriod.allowUserPurchase;
        this.jackpotAmount = playPeriod.jackpotAmount;
        this.playPeriod = playPeriod;
      }
    })

    this.loadTickets();
  }

  loadTickets(): void {
    this.ticketService.getTickets(this.page, this.pageSize).subscribe((response) => {

      this.tickets = response.content.map(t => ({
        ...t,
        numbers: t.number.split('-')
      }))

      this.pagination = {
        ...this.pagination,
        currentPage: this.page,
        totalPages: Math.ceil(response.pageInfo.totalItems / this.pageSize),
      }
      this.cdr.detectChanges();
      this.loaderService.hideLoader();
    })
  }

  onPageChange(page: number): void {
    this.page = page
    this.loadTickets();
  }

  ngAfterViewChecked(): void {
    const element = document.querySelector('.item-text');
    if (element && element.classList.contains('is-hidden')) {
      setTimeout(() => {
        element.classList.remove('is-hidden');
        element.classList.add('animate');
      }, 2000);
    }
    this.loaderService.hideLoader();
  }

  openLoginModal(): void {
    this.modalService.openModal('login');
  }

  noticeJustPlayed(): void {
    this.notificationService.showError('You have already played for this round.');
  }

}
